import React, { useState } from "react";
import { trackError } from "../../../../lib/metrics";

const CORRECT_CODE = "3241";

export default function SessionUnlock({ onSuccess, sessionCode, stage = 2, playerId }) {
  const [code, setCode] = useState("");
  const [error, setError] = useState(false);
  const [status, setStatus] = useState("idle");

  const handleSubmit = (e) => {
    e.preventDefault();

    if (code.trim() === CORRECT_CODE) {
      setStatus("success");
      setTimeout(() => { onSuccess?.(); }, 800);
    } else {
      setError(true);
      setStatus("idle");
      trackError({ sessionCode, stage, playerId, reason: "s2.p4.session.wrong_code", meta: { attempt: code.trim() } });
      setTimeout(() => setError(false), 2000);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-[70vh] py-12 px-4 bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950">
      <div className="w-full max-w-md space-y-8">
        <div className="text-center">
          <div className="w-20 h-20 mx-auto bg-blue-500/10 border-2 border-blue-500/30 rounded-full flex items-center justify-center mb-4">
            <svg className="w-10 h-10 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
            </svg>
          </div>
          <div className="text-2xl font-semibold text-slate-200 mb-2">Session verrouillée</div>
          <div className="text-sm text-slate-400">M. SCHMITT — Tech Lead Frontend</div>
        </div>

        <form onSubmit={handleSubmit} className="bg-slate-900/60 border border-slate-700/50 rounded-xl p-8 space-y-6">
          <div>
            <label className="block text-xs uppercase tracking-wider text-slate-400 font-semibold mb-3">
              Code d'accès
            </label>
            <input
              type="text"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              placeholder="••••"
              maxLength={4}
              disabled={status === "success"}
              className={`
                w-full px-4 py-4 rounded-lg text-center
                bg-black/60 border-2
                ${error ? "border-red-500 text-red-400" : "border-slate-600 text-slate-200"}
                ${status === "success" ? "border-emerald-500 text-emerald-300" : ""}
                font-mono text-3xl tracking-widest
                focus:outline-none focus:border-blue-500
                transition-colors disabled:opacity-50
              `}
            />
            {error && (
              <div className="mt-3 text-sm text-red-400 flex items-center justify-center gap-2">
                <span>❌</span><span>Code incorrect</span>
              </div>
            )}
            {status === "success" && (
              <div className="mt-3 text-sm text-emerald-400 flex items-center justify-center gap-2">
                <span>✓</span><span>Authentification réussie</span>
              </div>
            )}
          </div>

          <button
            type="submit"
            disabled={status === "success" || code.length !== 4}
            className={`
              w-full px-4 py-4 rounded-lg font-semibold text-lg transition
              ${status === "success"
                ? "bg-emerald-600 text-white"
                : "bg-blue-600 hover:bg-blue-500 text-white disabled:bg-slate-700 disabled:text-slate-500 disabled:cursor-not-allowed"
              }
            `}
          >
            {status === "success" ? "Accès autorisé" : "Déverrouiller"}
          </button>
        </form>
      </div>
    </div>
  );
}